import { navLinks } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/15 text-background-50">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading text-base font-bold text-background-50">我的朋友他的妻子 · 阅读导览站</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              本站围绕《我的朋友他的妻子》整理故事梗概、人物图谱、分章导读与阅读渠道方向，帮助读者先了解剧情再决定从哪里读起。本站不提供、不存储原作正文。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-200">
                站内导航
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-200">
                更多内容
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#related" className="text-sm text-background-200/80 transition-colors hover:text-accent-200">
                  相关题材推荐
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>本页为读者整理与导读内容，作品存在多个流传版本，细节请以实际阅读版本为准。</p>
          <p>© {new Date().getFullYear()} 我的朋友他的妻子 · 阅读导览站</p>
        </div>
      </div>
    </footer>
  );
}